// import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
// import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary
import img01 from "./../../../assets/images/283.png";// Adjust the path as necessary

function WellbeingCorner() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Wellbeing
        <span className="text-orange-ef3e33 font-400"> corner</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
           <div className="service-title font-700 mb-3 text-uppercase">
            {/* Wellbeing corner
        <span className="text-orange-ef3e33 font-400"> Crew complaints</span> */}
      </div>
          <p className="text-primary-color mb-3">
            The wellbeing corner is under development, watch this space!!!!!!
          </p>

        <ul class="green-star-ul">
             <li style={{ display: 'block' }}>
              Mental Health 
             </li>
            <li style={{ display: 'block' }}>
             	Substance abuse
              </li>   
               <li style={{ display: 'block' }}>
             Health and fitness
              </li> 
               <li style={{ display: 'block' }}>
             Communicable diseases
              </li> 
               <li style={{ display: 'block' }}>
              Sexually transmitted diseases including HIV and AIDS
              </li> 
          </ul>
        </div>
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            {/* <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div> */}
          </div>        
        </div>
         
      </div>
      
      
      <p className="text-primary-color">
         If you require counselling kindly contact our Maritime Welfare Officer at <a href="mailto:welfare@samsa.org.za ">welfare@samsa.org.za </a> </p>  

    </>
  );
}

export default WellbeingCorner;